const SERVICE_GROUPS = [
  {
    label: 'Bodenarbeiten',
    patterns: ['boden', 'bodenarbeit', 'bodenleger', 'parkett', 'keramik', 'platten', 'belag'],
  },
  {
    label: 'Malerei',
    patterns: ['maler', 'malerei', 'streichen', 'anstrich', 'farbe'],
  },
  {
    label: 'Gipserei',
    patterns: ['gips', 'gipser', 'trockenbau', 'spachtel', 'verputz'],
  },
  {
    label: 'Schreinerei',
    patterns: ['schreiner', 'schreinerei', 'holz', 'tuer', 'turen', 'ture', 'turen', 'fenster', 'schrank'],
  },
];

export function inferServiceGroup(item = {}) {
  const haystack = [
    item.title,
    item.object_name,
    item.notes,
    item.private_notes,
    item.monteur_name,
  ].filter(Boolean).join(' ').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const match = SERVICE_GROUPS.find(group =>
    group.patterns.some(pattern => haystack.includes(pattern))
  );
  return match?.label || '';
}

export function getCompanyFilterLabel(item = {}) {
  return (item.monteur_company || '').trim() || inferServiceGroup(item);
}
